module.exports = __webpack_public_path__ + "img/img_create_control.4ad7b762.png";